export const WEBSITE_LEAD_INTERCEPTOR_COPY = {
  productName: "Website Lead Interceptor",

  // Settings page (/dashboard/integrations/web-widget)
  settingsSubtitle:
    "Embed the Website Lead Interceptor on your website and route leads to your AI employee.",
  settingsSaved: "Website Lead Interceptor settings saved.",
  activeLabel: "Website Lead Interceptor active",
  loadSettingsError: "Failed to load Website Lead Interceptor settings.",
  saveSettingsError: "Failed to save Website Lead Interceptor settings.",

  // Chats page (/dashboard/chat-web)
  chatsPageTitle: "Website Lead Interceptor Chats",
  chatsSubtitle: "Leads captured via the Website Lead Interceptor",
  loadChatsError: "Failed to load Website Lead Interceptor chats",
  chatsEmpty: "No Website Lead Interceptor chats yet",

  // GHL help text
  ghlLeadsSynced:
    "Website Lead Interceptor leads are synced to GHL automatically when a visitor",
  ghlChatsIncluded: "including Website Lead Interceptor chats when GHL is connected.",

  googleAdsSectionTitle: "Google Ads tracking",
  googleAdsConversionIdLabel: "Google Ads Conversion ID",
  googleAdsConversionIdHelp:
    "Install Google tag (gtag) on your website. The widget fires a conversion when a visitor successfully submits the intro form.",
  googleAdsConversionIdInvalid:
    "Google Ads Conversion ID must look like AW-123456789/AbCdEfGhIj",

  // Landing
  realEstateIntegration:
    "Seamless connection to your WhatsApp / Telegram or Website Lead Interceptor.",
};
